import React from "react";
import FormViewer from "../../components/FormViewer";
import LoaderButton from "../../components/LoaderButton";
import Modal from '../../components/Modal'
import HttpServices from "../../utils/Http.services";
import { checkPermission, checkTranslation, getObject, translate } from "../../utils/useful";
// import { countriesCode } from '../variables/countries'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import moment from "jalali-moment";
import { Bar, Bubble, Doughnut, HorizontalBar, Line, Pie, Polar, Radar, Scatter } from "react-chartjs-2";
import { getBoundingClientRect } from "../../utils/functions";
import { adminPages } from "../../variables/adminPages.js";
import tableComponents from '../../components/tableComponents'
import CircleBar from "../../components/CircleBar";
import { Collapse } from "react-collapse";
import Chart from "../../components/widgets/Chart.jsx";
import SelectInput from "../../components/inputs/SelectInput";
import DateInput from "../../components/inputs/DateInput";
import MultiSelectInput from "../../components/inputs/MultiSelectInput.jsx";

class AdminReport extends React.Component {
    state = {
        countries: [],
        box: [
            { title: '{{lang}}تعداد کل لیدهای دریافتی', number: 0, status: "0.7%+", color: "#eb3c2a", icon: '/images/icons/icons8-triangle-26-green.png', left: '-65px', key: 'totalCount' },
            { title: '{{lang}}تعداد کل لیدها در بازه زمانی انتخاب شده', number: 0, status: "0.7%+", color: "#eb3c2a", icon: '/images/icons/icons8-triangle-26-green.png', left: '-65px', key: 'filteredCount' },
        ],
        sections: [],
        headers: [],
        filter: {},


    }
    componentDidMount() {
        this.init()

        window.addEventListener('resize', this.getSize)
        this.getSize()

    }



    componentDidUpdate(prevProps) {
      
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.getSize)
    }

    waitForId = (tryTime) => {
        if (tryTime > 0) {
            if (this.props.applet) {
                // endDate = now (ms since epoch)
                const endDate = Date.now();

                // Work in Gregorian explicitly
                const now = moment(endDate).locale("en"); // ensure Gregorian, not Jalali

                const startOfThisMonth = now.clone().startOf("month");

                // If ≥1 full day has passed since month start (i.e., it's the 2nd or later),
                // use the 1st of the *current* month; otherwise (it's the 1st), use the 1st of *last* month.
                const startDate =
                    now.diff(startOfThisMonth, "days") >= 1
                        ? startOfThisMonth.valueOf()
                        : now.clone().subtract(1, "month").startOf("month").valueOf();

                this.getCount({}, 'totalCount')

                this.changeDate('startDate', startDate)
                setTimeout(() => {
                    this.changeDate('endDate', endDate)
                    setTimeout(() => {
                        this.doFilter()
                    }, 40);
                }, 40);
            } else {
                setTimeout(() => {

                    this.waitForId(tryTime - 1)
                }, 100);
            }
        }

    }


    init() {

        let endDate = new Date().getTime()
        let startDate = moment(endDate).subtract(7, 'days').startOf('day').valueOf();
        if (this.props.applet) {


            this.getCount({}, 'totalCount')

            this.changeDate('startDate', startDate)
            setTimeout(() => {
                this.changeDate('endDate', endDate)
                setTimeout(() => {
                    this.doFilter()
                }, 40);
            }, 40);
        } else {
            this.waitForId(10)
        }
        // console.log(endDate, startDate)
       
    }


    getSize = () => {
        if (this.chartContainer) {
            let bound = getBoundingClientRect(this.chartContainer)

            this.setState({ show: false, height: bound.height, width: bound.width }, () => {
                this.setState({ show: true })
            })
        }
    }








    



    changeDate = (key, date) => {

        let filter = this.state.filter

        if (!filter['values.date']) {
            filter['values.date'] = {}
        }
        if (key == "startDate") {
            filter['values.date']['$gte'] = date
        }
        if (key == 'endDate') {
            filter['values.date']['$lte'] = date
        }
        if (key == 'creator') {
            filter['creator'] = { $in: (Array.isArray(date) ? date : [date]) }

        }
        this.setState({ [key]: date, filter }, () => {

            if (this.state.endDate < this.state.startDate) {
                this.setState({ endDate: null })
            }

        })
    }


    doFilter = () => {

        if (this.chart) {
            this.chart.init()
        }

        this.getCount(this.state.filter, 'filteredCount')

    }


    getCount = (filter, key) => {


        let body = { filter: filter }
        body.frame = 'forms'
        body.filter.applet = this.props.applet?._id ?? this.props.applet
        HttpServices.request('getRecordsCount', body, (fetchResult, fetchError, fetchStatus) => {
            if (fetchError) {
                this.setState({ errors: fetchError.errors })
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.postDataFailed', description: fetchError.message })
                return
            }

            this.setState({ [key]: fetchResult.count })


        })


    }





    render() {

        return (

            <div className="w-100 h-100 pb-5" style={{ backgroundColor: "#eee" }}>

                <div className="py-2 main-container1" style={{ margin: '0 auto' }}>
                    <div className="row m-0" style={{}}>

                        <div className="col-12 " style={{}}>

                            <div className="row m-0 mt-3">

                            

                                <div className="w-100 mt-2 px-3 mb-2">
                                    <div className="w-100 card-box">
                                        <div className="w-100 filters-row">
                                            <div className="filter-item">
                                                <p className="text-smaller mb-1 px-1">از تاریخ</p>
                                                <div className="input-shell">
                                                    <DateInput
                                                        startOrEnd="start"
                                                        header={{ key: 'startDate', information: { placeholder: 'از ...' } }}
                                                        changeValue={this.changeDate}
                                                        data={this.state.startDate}
                                                    />
                                                </div>
                                            </div>

                                            <div className="filter-item">
                                                <p className="text-smaller mb-1 px-1">تا تاریخ</p>
                                                <div className="input-shell">
                                                    <DateInput
                                                        startOrEnd="end"
                                                        startDate={this.state.startDate ? this.state.startDate : (new Date).getTime()}
                                                        header={{ key: 'endDate', information: { placeholder: 'تا ...' } }}
                                                        changeValue={this.changeDate}
                                                        data={this.state.endDate}
                                                    />
                                                </div>
                                            </div>

                                            <div className="filter-item">
                                                <p className="text-smaller mb-1 px-1">{translate('salesperson')}</p>
                                                <div className="select-shell">
                                                    <MultiSelectInput
                                                        header={{
                                                            col: '12',
                                                            key: 'creator',
                                                            type: 'SelectInput',
                                                            information: {
                                                                label: '{{lang}}salesperson',
                                                                updateAfterSelect: true,
                                                                isSearchable: false,
                                                                address: 'employeeGetAll',
                                                                filter: {},
                                                                fields: { title: 'name', value: '_id' },
                                                                type: 'api',
                                                                placeholder: '{{lang}}Select',
                                                                required: false,
                                                                disabled: false,
                                                                restricted: true,
                                                                defaultUser: true
                                                            },
                                                            showMain: true
                                                        }}
                                                        headerkey="extra"
                                                        changeValue={this.changeDate}
                                                        data={this.state.creator}
                                                    />
                                                </div>
                                            </div>

                                            <div className="filter-action">
                                                <button
                                                    onClick={() => { this.doFilter(); }}
                                                    className="btn-filter"
                                                >
                                                    <p className="text-small">{translate('فیلتر')}</p>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>



                                {this.state.box.map((item, index) => {
                                    return (
                                        <div className=" my-2 col-12 col-sm-6 col-md-6 col-lg-6 p-md-0" style={{}}>
                                            <div className="mx-md-3 flexcb p-3 h-100" style={{ boxShadow: "0px 0px 10px 0px #10101010", background: "#fff", borderRadius: 8, }}>

                                                <div>
                                                    <p className="" style={{ fontSize: 20, fontWeight: '400' }}>{this.state[item.key]}</p>
                                                    <p className="" style={{ fontSize: 12, fontWeight: '400', color: "gray", }}>{checkTranslation(item.title)}</p>
                                                </div>
                                                {/* {(index != 0 && this.state.percentCheck) && (
                                                    <div className="flexcc mt-3">
                                                        <CircleBar color={item.color} percent={Number(item.percent?.toFixed(0))} />

                                                    </div>
                                                )} */}
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>



                            <div className="row m-0" style={{}}>
                                <div className="col-12 col-md-12 my-3 " >
                                    <div className="h-100" style={{ boxShadow: "0px 0px 30px 0px #10101010", background: "#fff", borderRadius: 8, }}>


                                        <div style={{ borderBottom: '1px solid #eee' }}>
                                            <div className="py-3 flexcc" >
                                                <p style={{ fontSize: 14 }}>{checkTranslation('{{lang}}لیدها در اساس نوع آشنایی')}</p>
                                            </div>
                                        </div>


                                        <div className="p-2" style={{ borderRadius: 8 }}>

                                            <Chart applet={this.props.applet} ref={el => this.chart = el} header={{ information: { type: 'bar', collection: 'forms', style: 'vertical', x_axis: 'values.howHeardAboutUs', filter: this.state.filter } }} data={{ type: 'bar', collection: 'forms', style: 'vertical', x_axis: 'values.howHeardAboutUs', filter: this.state.filter }} />
                                        </div>
                                        <div className="p-2" style={{ borderRadius: 8 }}>

                                            <Chart applet={this.props.applet} ref={el => this.chart = el} frame={'forms'} header={{ information: { type: 'table', collection: 'forms', style: 'vertical', x_axis: 'values.model', filter: this.state.filter } }} data={{ type: 'table', collection: 'forms', style: 'vertical', x_axis: 'values.model', valueTitle: "تعداد پیش ثبت نام قطعی", filter: this.state.filter, populates: adminPages.forms.populates }} />
                                        </div>
                                        <div className="p-2" style={{ borderRadius: 8 }}>

                                            <Chart applet={this.props.applet} ref={el => this.chart = el} frame={'forms'} header={{ information: { type: 'matrix', collection: 'forms', x_axis: 'creator', groupBy: 'values.model', filter: this.state.filter } }} data={{ type: 'matrix', collection: 'forms', style: 'vertical', x_axis: 'creator', groupBy: 'values.model', filter: this.state.filter, populates: adminPages.forms.populates }} />

                                        </div>
                                    </div>

                                </div>



                            </div>

                        </div>
                    </div>
                </div>
            </div >
        );

    }
}



const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null, { forwardRef: true }
)(AdminReport);
